import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Cookies from 'js-cookie'

let search = window.location.search
let params = new URLSearchParams(search)

let hasError = params.get('error') !== null

const LoginPage = () => {
  return (
    <>
      <Helmet
        meta={[
          {
            name: 'robots',
            content: 'noindex,nofollow',
          },
        ]}
      />
      <div style={{ height: '80px' }}></div>
      <div className='container'>
        <div class='row'>
          <div className='col-md-12'>
            <h2 className='form-signin-heading'>
              <strong>Sign In</strong>
            </h2>
            <hr />
            <br />
          </div>
        </div>

        <div class='row'>
          <div className='col-md-6'>
            <img
              title=''
              alt=''
              data-displaymode='Original'
              className='img-fluid'
              src='https://cdn.shopify.com/s/files/1/0737/7593/9824/files/ws_BNHRPhotos4765vs.jpg'
            />
          </div>

          <div className='col-md-6'>
            <div class='row '>
              <div className='col-md-12'>
                <form className='form-signin' method='post' action='/login'>
                  {hasError && (
                    <div class='alert alert-danger' role='alert'>
                      Failed to login
                    </div>
                  )}

                  <p>
                    <label htmlFor='username' className='sr-only'>
                      Employee ID Number
                    </label>
                    <input
                      type='text'
                      id='username'
                      name='username'
                      className='form-control'
                      placeholder='Employee ID Number'
                      required
                      autoFocus
                    />
                  </p>
                  <p>
                    <label htmlFor='password' className='sr-only'>
                      Password
                    </label>
                    <input
                      type='password'
                      id='password'
                      name='password'
                      className='form-control'
                      placeholder='Password'
                      required
                    />
                  </p>
                  <p>
                    <input type='checkbox' name='remember-me' /> Remember me
                  </p>
                  <input
                    name='_csrf'
                    type='hidden'
                    value={Cookies.get('XSRF-TOKEN')}
                  />
                  <button className='btn btn-outline-dark' type='submit'>
                    Sign in
                  </button>
                </form>
                <br />
                <br />
              </div>
              <div className='col-md-12'>
                <h5>Instructions</h5>
                <p className='lzead'>
                  <p className='lzead'>
                    Welcome to the internal Barnes & Noble Careers Site! We are
                    excited that you are interested in new opportunities within
                    the company. Please use your network credentials to sign in
                    and start exploring.
                  </p>

                  <p className='lzead'>
                    We have included testimonials from many booksellers
                    throughout the company, so you can see their successful
                    career paths. You can search for Retail, Home Office and
                    Distribution Jobs. If you need assistance with administering
                    your network account, please visit Barnes & Noble Identity
                    Center <a href='http://bnidentity'>here</a>.
                  </p>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container'></div>
    </>
  )
}

export default LoginPage
